import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import { REACH_GOAL_CLICK_TYPE } from "../constants/common";
import { AnalyticsPusherModal } from "../utils/analytics";
export var withAnalyticsModal = function withAnalyticsModal(WrappedComponent) {
  return /*#__PURE__*/memo(function (props) {
    var handleView = function handleView() {
      var _props$onView;
      (_props$onView = props.onView) === null || _props$onView === void 0 ? void 0 : _props$onView.call(props);
      AnalyticsPusherModal.pushViewEvent("".concat(props.blockIndex));
      AnalyticsPusherModal.pushReachGoal("".concat(props.blockIndex), props.blockIndex, 0, REACH_GOAL_CLICK_TYPE.PopupView);
    };
    var handleClick = function handleClick(text, index) {
      var _props$onClick;
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, text, index);
      AnalyticsPusherModal.pushClickEvent(_defineProperty({}, props.blockIndex, text));
      AnalyticsPusherModal.pushReachGoal(text, props.blockIndex, index, REACH_GOAL_CLICK_TYPE.PopupButtonClick);
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      onClick: handleClick,
      onView: handleView,
      "data-t-id": "src-hocs"
    }));
  });
};